module.exports = __webpack_public_path__ + "img/m5-Starbucks.20d6a383.png";